export class HeaderMainData {

  public headTime: string;

  public userName: string;

  // 課題No3 start
  // 前回ログイン日時
  public zenkaiLoginNitiji: string;
  // 課題No3 end
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/header/header-main-data.ts